import Vue from "vue";
import VueRouter from "vue-router";
import Camere from "../views/camere.vue";
import Errore from "../views/errore.vue";
import Form from "../views/form.vue";
import Grazie from "../views/grazie.vue";
import GrazieCheckin from "../views/graziecheckin.vue";
import Proposte from "../views/proposte.vue";
import Riepilogo from "../views/riepilogo.vue";
import Ristorante from "../views/ristorante.vue";
import RistoranteAnnulla from "../views/ristorante_annulla.vue";
import Servizi from "../views/servizi.vue";
import Spa from "../views/spa.vue";
import SpaAnnulla from "../views/spa_annulla.vue";
import Spiaggia from "../views/spiaggia.vue";
import SpiaggiaAnnulla from "../views/spiaggia_annulla.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "camere",
    component: Camere
  },
  {
    path: "/servizi",
    name: "Servizi",
    component: Servizi
  },
  {
    path: "/form",
    name: "Form",
    component: Form
  },
  {
    path: "/errore",
    name: "Errore",
    component: Errore
  },
  {
    path: "/grazie",
    name: "Grazie",
    component: Grazie
  },
  {
    path: "/riepilogo",
    name: "Riepilogo",
    component: Riepilogo
  },
  {
    path: "/graziecheckin",
    name: "Grazie Checkin",
    component: GrazieCheckin
  },
  {
    path: "/proposte",
    name: "Proposte",
    component: Proposte
  },
  // Prenotazione online dei tavoli del ristorante, e annullamento dal link dell'email.
  {
    path: "/ristorante",
    name: "Ristorante",
    component: Ristorante
  },
  {
    path: "/ristorante/annulla",
    name: "Ristorante annulla",
    component: RistoranteAnnulla
  },
  // Prenotazione online degli ombrelloni, e annullamento dal link dell'email.
  {
    path: "/spiaggia",
    name: "Spiaggia",
    component: Spiaggia
  },
  {
    path: "/spiaggia/annulla",
    name: "Spiaggia annulla",
    component: SpiaggiaAnnulla
    // Prenotazione online dei trattamenti della SPA, e annullamento dal link dell'email.
  },
  {
    path: "/spa",
    name: "Spa",
    component: Spa
  },
  {
    path: "/spa/annulla",
    name: "Spa annulla",
    component: SpaAnnulla
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
